/*@ngInject*/
const QuoteMediator = function (quoteRepository, quoteListRepository) {
    this.getQuote = function (quoteId) {
        return quoteRepository.getQuote(quoteId);
    };

    this.getQuoteList = function (submissionId, proposalId) {
        return quoteListRepository.getQuoteList(submissionId, proposalId);
    };

    this.deleteQuoteListRegistration = function (submissionId) {
        return quoteRepository.deleteQuoteListRegistration(submissionId);
    };
};

angular.module('gw-um-submission')
    .service('quoteMediator', QuoteMediator);
